import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonModal } from '@ionic/react';
import DishModalContent from './DishModalContent';

export default function DishModalTrigger(props) {
    const { dish, showDishModal, setShowDishModal, onDetailsOpenHandler } = props;

    const { t } = useTranslation();

    const onCloseHandler = () => setShowDishModal(false);

    return (
        <React.Fragment>
            <span onClick={onDetailsOpenHandler} className="dish-modal-trigger cursor-pointer py-1 underline text-sm text-blue-500">{dish.has_nutritional_values ? t("dishmodaltrigger.span_1_b") : t("dishmodaltrigger.span_1_a")}</span>

            <IonModal isOpen={showDishModal} onDidDismiss={onCloseHandler}>
                <DishModalContent dish={dish} closerHandler={onCloseHandler}></DishModalContent>
            </IonModal>
        </React.Fragment>
    );
}
